import { createFileRoute } from '@tanstack/react-router'

import { objectiveFiltersSchema } from '@/modules/objective/core/objective.schema'
import { ObjectivesPage } from '@/modules/objective/presentation/pages/Objectives'

export const Route = createFileRoute('/_authenticated/objectives/')({
  component: ObjectivesPage,
  head: () => ({
    meta: [
      {
        title: 'Objectives',
      },
    ],
  }),
  validateSearch: objectiveFiltersSchema,
})
